import { memo } from 'react'

import {
  type V1FormElementState,
  type V1FormElementUiTextField,
  type V1FormElementContentState,
  V1FormElementStateType
} from 'mnvm-mypage-app-ts-if'
import {
  InputTextArea,
  type StyledTextareaProps
} from '@/components/base/Form/InputTextArea'
import { fontSize } from '@/styles/font'
import { align } from '@/styles/display'

export interface FormElementTextAreaFieldProps extends StyledTextareaProps {
  isEdit: boolean
  textFieldUiIFM: V1FormElementUiTextField
  formElementState: V1FormElementState
  elemenErrorMessage?: string
  onChange: (newElementState: V1FormElementState) => void
}

const FormElementTextAreaField = ({
  isEdit,
  textFieldUiIFM,
  elemenErrorMessage,
  formElementState,
  onChange
}: FormElementTextAreaFieldProps): JSX.Element => {
  const textState = formElementState.contentStates?.at(0)?.text ?? ''

  if (!isEdit) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: textState?.replace(/\r\n/g, '<br>')
        }}
        style={{ fontSize: fontSize.S, textAlign: align.LEFT }}
      ></div>
    )
  }

  if (formElementState.type === V1FormElementStateType.Text) {
    const onChangeText = (value: string): void => {
      onChange({
        ...formElementState,
        type: formElementState.type,
        contentStates: [
          {
            text: value
          } satisfies V1FormElementContentState
        ]
      })
    }

    return (
      <InputTextArea
        value={textState?.replace(/\r/g, '')}
        onChange={(value) => {
          onChangeText(value)
        }}
        placeholder={textFieldUiIFM?.placeholder}
        errorMessage={elemenErrorMessage}
      />
    )
  }

  return (
    <>
      <div>not implemented</div>
    </>
  )
}

export default memo(FormElementTextAreaField)
